import vClickOutside from 'v-click-outside'
import Vue from 'vue'

Vue.use(vClickOutside)
